<script lang="ts">
	import { page } from '$app/stores';
	import { translations } from '$lib/i18n/translations';

	export let showLinkText: boolean = true;
	export let href: string = '';

	const colors = $page.data.property.colors;
	const t = translations($page.data.property.language);
</script>

<div class="flex items-center justify-between gap-6">
	<div class="grow">
		<hr />
	</div>
	<div>
		<a {href} class={`text-sm inline-flex items-center group ${colors.text} hover:${colors.hover}`}>
			{#if showLinkText}
				<span class="mr-2">
					<span>{t('seemore')}</span>
					<span
						class={`block max-w-0 group-hover:max-w-full transition-all duration-500 h-0.5 ${colors.hoverBackground}`}
					></span>
				</span>
			{/if}
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 16 16"
				fill="currentColor"
				class="w-4 h-4"
			>
				<path
					fill-rule="evenodd"
					d="M2 8a.75.75 0 0 1 .75-.75h8.69L8.22 4.03a.75.75 0 0 1 1.06-1.06l4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 0 1-1.06-1.06l3.22-3.22H2.75A.75.75 0 0 1 2 8Z"
					clip-rule="evenodd"
				/>
			</svg>
		</a>
	</div>
</div>
